import type { BasketItem } from '../../schema/basket'
import type { WebshopPackage } from '../../schema/webshop-package'

/**
 * Given a list of product codes (duplicates possible), recreates list of basket items
 */
export const buildBasketProducts = (productCodes: string[], products: WebshopPackage[]): BasketItem[] =>
  productCodes
    .reduce((previous, current) => {
      if (previous.indexOf(current) === -1) {
        return previous.concat(current)
      }
      return previous
    }, [])
    .map(uniqueCode => {
      const occurrences = productCodes.filter(code => uniqueCode === code).length
      const item = products.find(product => product.productCode === uniqueCode)

      if (item) {
        return {
          amount: occurrences,
          price: occurrences * item.price,
          product: item,
        }
      }

      return null
    })
    .filter(Boolean)
